// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1b0aJ","rootCenter":"LoadMoreObserver_rootCenter__e33EE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2jBB-"};